import axios from 'axios'

export default {
  data () {
    return {
      reRendering: 1,
      stockModelParam: {
        hasOutOfStock: false,
        cartChecked: false,
        cartErrors: {},
        members: {}
      },
      currentMemberIndex: 0,
      stockModelValue: {
        outOfStocks: {},
        stockList: {},
        shareSizesList: {},
        items: {
          'etc': {
            'package': {},
            'single': {}
          }
        },
        names: {},
        boards: {},
        setItems: {},
        systemOptions: {},
        prices: {},
        alerts: {}
      },
      selectOptions: {
        items: {
          'etc': {
            'package': {},
            'single': {}
          }
        },
        ages: [
          '00', '06', '09', '12', '18', '19', '20', '21', '30', '40', '50', '60', '70'
        ],
        sex: [
          'M', 'F'
        ],
        stance: [
          'regular', 'goofy', 'unknown'
        ],
        item: [
          'snb', 'ski', 'ssk'
        ],
        itemOptions: {
          'main_snb_pac': {
            'main_snb_board': 1,
            'main_snb_boot': 1,
            'main_snb_wear': 1,
            'main_snb_ticket': 1,
            'main_snb_accessory': 1
          },
          'main_snb_set': {
            'main_snb_board': 1,
            'main_snb_boot': 1,
            'main_snb_wear': 1
          },
          'main_snb_single': {
            'main_snb_board': 0,
            'main_snb_boot': 0,
            'main_snb_wear': 0
          },
          'main_ski_pac': {
            'main_ski_board': 1,
            'main_ski_boot': 1,
            'main_ski_wear': 1,
            'main_ski_pole': 1,
            'main_ski_ticket': 1,
            'main_ski_accessory': 1
          },
          'main_ski_set': {
            'main_ski_board': 1,
            'main_ski_boot': 1,
            'main_ski_wear': 1,
            'main_ski_pole': 1
          },
          'main_ski_single': {
            'main_ski_board': 0,
            'main_ski_boot': 0,
            'main_ski_wear': 0,
            'main_ski_pole': 0
          },
          'main_ssk_pac': {
            'main_ssk_board': 1,
            'main_ssk_boot': 1,
            'main_ssk_wear': 1,
            'main_ssk_ticket': 1,
            'main_ssk_accessory': 1
          },
          'main_ssk_set': {
            'main_ssk_board': 1,
            'main_ssk_boot': 1,
            'main_ssk_wear': 1
          },
          'main_ssk_single': {
            'main_ssk_board': 0,
            'main_ssk_boot': 0,
            'main_ssk_wear': 0
          }
        },
        itemSnb: [
          'main_snb_pac', 'main_snb_set', 'main_snb_single'
        ],
        itemSnbEtc: [
          'etc_helmet', 'etc_boot', 'etc_wear'
        ],
        itemSki: [
          'main_ski_pac', 'main_ski_set', 'main_ski_single'
        ],
        itemSkiEtc: [
          'etc_helmet', 'etc_boot', 'etc_wear'
        ],
        itemSsk: [
          'main_ssk_pac', 'main_ssk_set', 'main_ssk_single'
        ],
        itemSskEtc: [
          'etc_helmet', 'etc_boot', 'etc_wear'
        ],
        weight: [],
        skier_type: []
      },
      memberParams: {
        first_name: '',
        last_name: '',
        sex: 'M',
        age: '21',
        height: '160',
        weight: '', // 体重コード
        skier_type: '', // スキーヤータイプコード
        shoe: '250',
        stance: '',
        request: '',
        item: '',
        rentalItems: {},
        itemInactive: {},
        itemCategory: '',
        itemCategoryName: '',
        itemCategoryPrice: 0,
        isRepresentative: false,
        req: {
          wear: '',
          ski: '',
          snb: '',
          ssk: '',
          weight: '',
          text: ''
        }
      }
    }
  },
  created () {
    // this.getStockList(true)
    // console.log('checkStock.getStockList', this.stockModelValue.stockList)
  },
  methods: {
    out (message, indent = 0) {
      let space = ''
      for (let i = 0; i < indent; i++) {
        space += '    '
      }
      console.log(space + 'check: ' + message)
    },
    async checkStockByMember (member, index) {
      this.stockModelParam.cartChecked = false
      this.memberParams = member
      // let itemCategory = this.memberParams.itemCategory
      let _self = this
      _self.currentMemberIndex = index
      _self.stockModelParam.members[index] = {
        memberData: member,
        hasOutOfStock: false,
        recSizes: {},
        nowLoading: true
      }
      // エラーを削除
      if (_self.stockModelParam.cartErrors[index]) {
        delete _self.stockModelParam.cartErrors[index]
      }
      _self.stockModelParam.members[index].hasOutOfStock = false
      await this.getItems(true)
      await _self.getRecSizes(index)
      await _self.checkSetItems().then(value => {
        if (_self.stockModelParam.members[index].hasOutOfStock) {
          _self.stockModelParam.cartErrors[index] = 'セットに欠品中のアイテムが含まれています'
        }
      })
      await _self.checkRentalItems(member, index)
      _self.stockModelParam.members[index].nowLoading = false
      this.out('カート情報の更新', 1)
      _self.$forceUpdate()
    },
    async checkRentalItems (member, memberIndex) {
      let _self = this
      if (member.rentalItems) {
        _self.out('単品アイテムチェック', 1)

        let objectKeys = Object.keys(member.rentalItems)
        for (let i = 0; i < objectKeys.length; i++) {
          let key = objectKeys[i]
          let stockStatus = _self.getStockState(key)
          if (stockStatus.res !== 1) {
            _self.out('単品アイテム欠品: ' + key, 2)
            _self.stockModelParam.members[memberIndex].hasOutOfStock = true
          }
        }
      }
      if (_self.stockModelParam.members[memberIndex].hasOutOfStock) {
        console.log('     ------------------- check: ' + _self.memberParams.first_name)
        _self.stockModelParam.cartErrors[memberIndex] = 'message.itemIsOutOfStock'
      }
      return true
      // console.log('checkStock.cartErrors', _self.stockModelParam.cartErrors)
    },
    async getStockList (init = false) { // Member.vueと同様
      console.log('checkStock.getStockList ++++++++++++++++++++++++++++++')
      let _self = this
      const str = this.$root.$root.$store.state.rentalDate
      const start = str.replace(/\//g, '-')
      const ui = this.$root.$root.$route.query.ui
      let url = this.$root.baseURL + 'getStockInfo/' + ui + '/' + start + '/' + this.$root.$store.state.reserve_term
      await axios.get(url).then(response => {
        this.formObject(response.data).then(value => {
          if (init) {
            _self.getShareSizes()
          }
        })
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        console.log('++++++++++++++++++++++++ checkStock.getStockList')
      })
    },
    async formObject (data) { // Member.vueと同様
      let _self = this
      let objectKeys = Object.keys(data)
      for (let i = 0; i < objectKeys.length; i++) {
        let key = objectKeys[i]
        let stock = data[key]
        _self.stockModelValue.stockList[key] = stock
      }
    },
    async getShareSizes () { // Member.vueと同様
      let _self = this
      await axios.post(this.$root.$root.baseURL + 'getShareSizes', {
        params: Object.keys(this.stockModelValue.stockList)
      }).then(response => {
        _self.stockModelValue.shareSizesList = response.data
      }).catch(error => {
        console.log('getShareSizes', error)
      })
    },
    async getRecSizes (index) { // Member.vueと同様
      this.out('getRecSizes index: ' + index, 2)
      this.reRendering = this.reRendering > 8 ? 1 : this.reRendering + 1
      let data = this.stockModelParam.members[index].memberData
      data.ui = this.$root.$root.$route.query.ui ? this.$root.$root.$route.query.ui : ''
      await axios.post(this.$root.$root.baseURL + 'getRecSizes', {
        params: data
      }).then(response => {
        this.stockModelParam.members[index].recSizes = response.data
        console.log('        check: getRecSizes', this.stockModelParam.members[index].recSizes)
      }).catch(error => {
        console.log('        error: getRecSizes', error)
      }).finally(() => {
        this.out('getRecSizes:finally index: ' + index, 2)
        this.checkSetItems()
      })
    },
    async checkSetItems () {
      let currentIndex = this.currentMemberIndex
      let item = this.stockModelParam.members[currentIndex].memberData.item
      let categoryId = this.stockModelParam.members[currentIndex].memberData.itemCategory
      if (item === '' && categoryId === '') {
        return
      }
      let children = null
      let _self = this
      // console.log('checkStock::アイテム', this.stockModelValue.items, 'item:', item)
      this.$_.each(this.stockModelValue.items[item]?.package, function (a) {
        _self.out('セットアイテムチェック', 1)
        // _self.out('categoryId:' + categoryId + ' a.category_id:' + a.category_id, 2)
        if (a.category_id === categoryId && a.children) {
          children = a.children
          if (children) {
            for (let i = 0; i < children.length; i++) {
              let childId = children[i]
              let stockStatus = _self.getStockState(childId)
              if (stockStatus.res !== 1) {
                _self.stockModelParam.members[currentIndex].hasOutOfStock = true
                // _self.out('セットアイテム欠品', 1)
                // _self.out('categoryId:' + categoryId + ' childId:' + childId, 2)
              }
            }
          }
        }
      })
    },
    getStockState (id) {
      let sizes = this.stockModelParam.members[this.currentMemberIndex].recSizes
      let sizeKey
      let key = 0.0
      let idStr = String(id)
      // todo アイテム別欠品メッセージ準備中
      let soldoutMessages = {
        'board_size': '身長を変更すると在庫が残っている場合があります。',
        'ski_size': '身長を変更すると在庫が残っている場合があります。',
        'shoe_size_ski': '足長を変更すると在庫が残っている場合があります。',
        'shoe_size_board': '足長を変更すると在庫が残っている場合があります。',
        'short_ski_size': '身長を変更すると在庫が残っている場合があります。',
        'wear_size': '身長を変更すると在庫が残っている場合があります。',
        'rubber_size': '足長を変更すると在庫が残っている場合があります。'
      }

      // ToDo: IDで仕分けはできないのでitem.tagsから仕分けるか

      switch (idStr) {
        case '2': // 大人スノボ板
        case '13': // 小人スノボ板
        case '145': // 小人スノボ板
        case '177': // 小人スノボ板
        case '242': // pia
        case '265': // pia
        case '351': // washi
        case '372': // washi
          sizeKey = 'board_size'
          break
        case '5': // 大人スキー板
        case '16': // 小人スキー板
        case '154': // 小人スキー板
        case '184': // 小人スキー板
        case '248': // pia
        case '271': // pia
        case '356': // washi
        case '377': // washi
          sizeKey = 'ski_size'
          break
        case '7': // 大人スキーストック
        case '18': // 小人スキーストック
        case '156': // 小人スキーストック
        case '186': // 小人スキーストック
        case '251': // pia
        case '274': // pia
        case '359': // washi
        case '380': // washi
          sizeKey = 'skipole_size'
          break
        // case '3': // 大人スノボ靴
        // case '6': // 大人スキー靴
        // case '14': // 小人スノボ靴
        // case '17': // 小人スキー靴
        //   key = sizes['shoe_size'].toFixed(1)
        //   break
        case '3': // 大人スノボ靴
        case '14': // 小人スノボ靴
        case '146': // 大人スノボ靴
        case '178': // 小人スノボ靴
        case '243': // pia
        case '266': // pia
        case '352': // washi
        case '373': // washi
          sizeKey = 'shoe_size_board'
          break
        case '6': // 大人スキー靴
        case '17': // 小人スキー靴
        case '155': // 大人スキー靴
        case '185': // 小人スキー靴
        case '250': // pia
        case '273': // pia
        case '358': // washi
        case '379': // washi
          sizeKey = 'shoe_size_ski'
          break
        case '9': // 大人ショートスキー板
        case '35': // 小人ショートスキー板
        case '163': // 大人ショートスキー板
        case '191': // 小人ショートスキー板
        case '249': // pia
        case '272': // pia
        case '357': // washi
          sizeKey = 'shortski_size'
          // key = '100.0'
          break
        case '10': // 大人ウェア上下
        case '21': // 小人ウェア上下
        case '19': // 小人ウェア上下
        case '23': // 小人ウェア上下
        case '165': // 大人ウェア上下
        case '166': // 大人ウェア上下
        case '193': // 小人ウェア上下
        case '194': // 小人ウェア上下
        case '256': // 小人ウェア上下
        case '257': // 小人ウェア上下
        case '258': // 小人ウェア上下
        case '279': // 小人ウェア上下
        case '280': // 小人ウェア上下
        case '292': // 小人ウェア上下
        case '362': // 小人ウェア上下
        case '363': // 小人ウェア上下
        case '383': // 小人ウェア上下
        case '384': // 小人ウェア上下
          sizeKey = 'wear_size'
          break
        case '11': // 大人ヘルメット
        case '20': // 大人ヘルメット
        case '167': // 大人ヘルメット
        case '195': // 大人ヘルメット
        case '262': // 大人ヘルメット
        case '285': // 大人ヘルメット
        case '367': // 大人ヘルメット
        case '388': // 大人ヘルメット
          sizeKey = 'met_size'
          break
        case '33': // 小人長靴
        case '66': // 大人長靴
        case '368': // 大人長靴
        case '389': // 大人長靴
          sizeKey = 'rubber_size'
          break
        default: // 20: 小人ヘルメット, 21: 大人ウェア単品, 23: 小人ウェア単品, 25: 土日祝リフト１日券(大人)食事券, 26: 平日リフト１日券(大人), 27: ファミリーリフト１日券, 28: 小人リフト１日券, 29: レンタルシーズン券 (スタッフ), 30: レンタル１日券 (スタッフ), 36: 大人小物セット, 37: 小人小物セット, 44: 大人共通リフト１日券, 45: 小人共通リフト１日券
          sizeKey = null
          key = '0.0'
          break
      }

      if (sizes[sizeKey]) {
        key = sizes[sizeKey].toFixed(1)
      }
      this.out('getStockState: ' + id + ':' + this.stockModelValue.names[id] + ' sizekey: ' + sizeKey + ' key: ' + key, 2)
      console.log('        check: sizes:', sizes)
      let result = {
        res: 1, // 0: 欠品中, 1: 在庫あり, -1: 売り止め
        message: '',
        additionalMessage: '',
        stockKey: '',
        sizeKey: '',
        rest: 9999
      }
      if (this.stockModelValue.stockList && this.stockModelValue.stockList[id]) {
        let strKey = String(key)
        if (strKey === '0') {
          strKey = '0.0'
        }
        if (sizeKey) {
          result.sizeKey = sizeKey
        }
        if (strKey) {
          result.stockKey = strKey
        }
        // console.log('id:' + id + ' strKey:' + strKey + ' stockList:' + this.stockModelValue.stockList[id][strKey])
        result.stockKey = strKey
        let stock = strKey && strKey.length > 0 && this.stockModelValue.stockList[id] && this.stockModelValue.stockList[id][strKey] ? this.stockModelValue.stockList[id][strKey] : null

        if (stock === null) {
          // category_idを読みかえして存在するかチェック
          if (this.stockModelValue.shareSizesList[id]) {
            let convertedId = this.stockModelValue.shareSizesList[id]
            // console.log('convertedId: ' + id + ' => ' + convertedId)
            stock = strKey && strKey.length > 0 && this.stockModelValue.stockList[convertedId] && this.stockModelValue.stockList[convertedId][strKey] ? this.stockModelValue.stockList[convertedId][strKey] : null
          }
        }
        // res 1: 在庫あり, -1: 売り止め, 0: 欠品中

        // リストにない場合 スルー
        if (!stock) {
          this.out('stock not found id: ' + id + 'strKey: ' + strKey, 2)
          result.res = 0
        } else {
          // 以下で在庫判定

          // 残り数 文字列を数値に変換
          result.rest = parseInt(stock.cnt_remain)

          if (result.rest > 0) {
            result.res = 1
          }
          // soldout
          if (this.showSoldOut && stock.is_soldout === true) {
            result.res = 0
            result.message = '欠品中'
          } else {
            if (result.rest < 1) { // 残り数がない場d = 203000004合
              result.res = 0
              result.message = '欠品中'
            } else if (result.rest < 5) { // 5個以下の場合
              result.message = '僅少'
            }
          }
        }
        if (result.res !== 1) {
          this.stockModelValue.outOfStocks[id] = {
            id: id,
            name: this.stockModelValue.names[id],
            stock: stock,
            key: key,
            message: soldoutMessages[sizeKey]
          }
          if (soldoutMessages?.[sizeKey]) {
            result.additionalMessage = soldoutMessages[sizeKey]
          }
          this.out('getStockState:欠品中 id:' + id + ' name: ' + this.stockModelValue.names[id] + ' key: ' + key + ' rest: ' + result.rest, 2)
          console.log('        check: result:', result)
          console.log('        check: stock:', stock)
        } else {
          this.out('getStockState:在庫あり ' + id + ' name: ' + this.stockModelValue.names[id] + ' key: ' + key + ' rest: ' + result.rest, 2)
        }
      }
      // soldout も allocate_stocksもfalseなら常に在庫あり表示
      // if (!this.showStocks && !this.showSoldOut) {
      //   result.res = 1
      //   result.rest = 9999
      // }
      // console.log('checkStock------------------------------getStockState', id, key, sizeKey, result)
      return result
    },
    refreshTotalPrice () {
      return 0
    },
    itemReset () {
      return true
    },
    async getItems (runReset) {
      this.out('アイテム取得', 1)
      this.itemLoading = true
      let ui = this.$root.$root.$route.query.ui ? this.$root.$root.$route.query.ui : ''
      let introduceType = this.$root.$root.$route.query.int ? this.$root.$root.$route.query.int : ''
      let dev = this.$root.$root.$route.query.dev
      let url = this.$root.$root.baseURL +
        'items.json?ui=' + ui +
        '&int=' + introduceType +
        '&age=' + this.memberParams.age +
        '&height=' + this.memberParams.height +
        '&weight=' + this.memberParams.weight +
        '&skier_type=' + this.memberParams.skier_type +
        '&shoe=' + this.memberParams.shoe +
        '&sex=' + this.memberParams.sex +
        '&term=' + this.$root.$root.$store.state.reserve_term +
        '&start=' + this.$root.$root.$store.state.rentalDate +
        '&dev=' + dev
      let _self = this
      await axios.get(url, {
        params: this.data
      }).then(response => {
        if (runReset === true && !this.$_.isEqual(this.stockModelValue.names, response.data.names)) {
          _self.itemReset()
          _self.systemOptions = response.data.systemOptions
          _self.stockModelValue.prices = response.data.prices
          _self.stockModelValue.alerts = response.data.alerts
          _self.stockModelValue.names = response.data.names
          _self.stockModelValue.boards = response.data.boards
          _self.stockModelValue.setItems = response.data.setItems
          _self.memberParams.sizes = response.data.sizes
        }
        // this.stockModelValue.items = response.data.items
        if (_self.stockModelValue.items && Object.keys(_self.stockModelValue.items).length > 0) {
          // console.log('keys', Object.keys(_self.stockModelValue.items))
          // console.log('response keys ssk', response.data.items['ssk'])
          let itemsKeys = Object.keys(_self.stockModelValue.items)
          for (let i = 0; i < itemsKeys.length; i++) {
            let key = itemsKeys[i]
            if (!response.data.items[key]) {
              delete _self.stockModelValue.items[key]
            }
          }
        }
        let tmp = response.data.items
        _self.$_.each(tmp, function (v, itemGroupName) {
          _self.stockModelValue.items[itemGroupName] = {}
          _self.$_.each(v, function (vv, itemTypeName) {
            _self.stockModelValue.items[itemGroupName][itemTypeName] = {}
            _self.$_.each(vv, function (vvv, categoryId) {
              _self.stockModelValue.items[itemGroupName][itemTypeName][vvv.sequence] = vvv
              // console.log('stockModelValue.items', itemGroupName, itemTypeName, vvv.sequence)
            })
          })
        })
        let newItems = []
        const obj = _self.stockModelValue.items.etc.single
        let objectKeys = Object.keys(obj)
        for (let i = 0; i < objectKeys.length; i++) {
          let key = objectKeys[i]
          // if (obj[key].name !== '大人ウェア単品' && obj[key].name !== '小人ウェア単品') {
          newItems.push(obj[key])
          // }
        }
        _self.stockModelValue.items.etc.single = newItems
        this.out('---アイテム取得', 1)
      }).catch(error => {
        console.log(error)
        return false
      }).finally(() => {
        _self.itemLoading = false
        _self.refreshTotalPrice()
        return true
      })
    }
  }
}
